import React from 'react';

const EntityBankForm = ({ formData, handleChange }) => {
  const labelWidth = 250; // px
  const paddingOffset = 60; // px: gap between label and edge of screen

  return (
    <div style={{ padding: '5px' }}>
      <h2 style={{ marginBottom: '20px' }}>Subscriber’s Wire Transfer Instructions:</h2>
      <>
        {[
          { label: "Bank Name:", name: "entityBankName" },
          { label: "Bank Address:", name: "entityBankLocation" },
          { label: "ABA Routing Number (U.S. Banks):", name: "entityAbaRoutingNumber" },
          { label: "Swift Code (non-U.S. Banks):", name: "entitySwiftCode" },
          { label: "Account Name:", name: "entityAccountName" },
          { label: "Account Number:", name: "entityAccountNumber" },
          { label: "Reference:", name: "entityReference" },
        ].map(({ label, name }) => (
          <div
            key={name}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '12px',
            }}
          >
            <label
              htmlFor={name}
              style={{
                minWidth: `${labelWidth}px`,
                marginRight: '10px',
                textAlign: 'left',
                whiteSpace: 'normal',
                lineHeight: '1.2',
                paddingTop: '4px',
              }}
            >
              {label}
            </label>
            <input
              id={name}
              type="text"
              name={name}
              value={formData[name]}
              onChange={handleChange}
              required={["entityAccountNumber", "entityAbaRoutingNumber"].includes(name)}
              style={{
                padding: '6px 10px',
                width: `calc(100vw - ${labelWidth + paddingOffset}px)`,
                maxWidth: '600px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}
            />
          </div>
        ))}
      </>
    </div>
  );
};

export default EntityBankForm;
